import { Injectable, inject } from '@angular/core';
import { BaseApiService, PaginatedResults } from '@bo/ng-api';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Video, VideoTag } from '../../_interfaces/howto-video';

@Injectable({
  providedIn: 'root',
})
export class HowtoVideoApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;

  URL_HOWTO_VIDEO: string = 'howto-video';
  URL_HOWTO_VIDEO_TAGS: string = 'howto-video/tags';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * Get all videos - paginated response
   *
   * @return Observable<PaginatedResults<Video[]>>
   */
  getHowtoVideos(queryParams: HttpParams): Observable<PaginatedResults<Video>> {
    const url = this.getUrl(this.URL_HOWTO_VIDEO, true);
    return this.http.get<Video>(url, { observe: 'response', params: queryParams }).pipe(
      map((res) => {
        return new PaginatedResults<Video>(res);
      }),
    );
  }

  /**
   * Get video by id
   *
   * @return Observable<Video>
   */
  getVideoById(id: string): Observable<Video> {
    const url = this.getUrl([this.URL_HOWTO_VIDEO, id], true);
    return this.http.get<Video>(url);
  }

  /**
   * Get all Howto video tags
   *
   * @return Observable<VideoTag[]>
   */
  getHowtoVideoTags(): Observable<VideoTag[]> {
    const url = this.getUrl(this.URL_HOWTO_VIDEO_TAGS, true);
    return this.http.get<VideoTag[]>(url);
  }
}
